import React from 'react';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';

const GradientRewardsIcon = () => (
  <>
    <svg width={0} height={0}>
      <linearGradient id="rewardColors" x1={1} y1={0} x2={1} y2={1}>
        <stop offset={0} stopColor="rgb(255, 255, 0)" />
        <stop offset={1} stopColor="rgb(255, 128, 0)" />
      </linearGradient>
    </svg>
    <EmojiEventsRoundedIcon sx={{ fill: "url(#rewardColors)" }} />
  </>
);

export default GradientRewardsIcon;